module.exports = __webpack_public_path__ + "static/media/ic-4.f8defc59.svg";